exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-a240b95c] {\n  padding: 0 0 10px 0;\n  border-bottom: 1px solid #eee;\n}\n.page-header[data-v-a240b95c] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n", ""]);

// exports
